import { useState } from "react";
import { useLenis } from "lenis/react";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { CONTACT } from "../data/content";
import Logo from "./Logo";

const LINKS = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Ongoing", href: "#ongoing" },
  { label: "Projects", href: "#projects" },
  { label: "Real Estate", href: "#real-estate" },
  { label: "Contact", href: "#contact" },
];

const slug = (s) => s.toLowerCase().replace(/\s+/g, "-");

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const lenis = useLenis();

  const go = (e, href) => {
    e.preventDefault();
    setOpen(false);
    lenis?.scrollTo(href, { offset: -64, duration: 1.4 });
  };

  return (
    <header
      data-testid="site-navbar"
      className="fixed top-0 inset-x-0 z-50 bg-white/85 backdrop-blur-md border-b border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
        <a
          href="#top"
          onClick={(e) => go(e, "#top")}
          data-testid="nav-logo-link"
          className="flex items-center gap-3 group"
        >
          <Logo />
        </a>

        <nav className="hidden lg:flex items-center gap-7">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => go(e, l.href)}
              data-testid={`nav-link-${slug(l.label)}`}
              className="font-mono text-[11px] tracking-[0.18em] uppercase text-slate-600 hover:text-blueprint-accent transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-6">
          <a
            href={CONTACT.phoneHref}
            data-testid="nav-phone-link"
            className="font-mono text-[11px] tracking-widest text-slate-600 hover:text-blueprint-accent transition-colors duration-300"
          >
            {CONTACT.phoneDisplay}
          </a>
          <a
            href="#contact"
            onClick={(e) => go(e, "#contact")}
            data-testid="nav-quote-button"
            className="inline-flex items-center gap-1.5 bg-prussian text-white font-mono text-[11px] tracking-[0.15em] uppercase px-4 py-2.5 hover:bg-blueprint-accent transition-colors duration-300"
          >
            Get a Quote <ArrowUpRight size={13} />
          </a>
        </div>

        <button
          data-testid="nav-mobile-menu-button"
          onClick={() => setOpen(!open)}
          className="lg:hidden text-prussian p-2"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div data-testid="nav-mobile-menu" className="lg:hidden border-t border-slate-200 bg-white">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => go(e, l.href)}
              data-testid={`nav-mobile-link-${slug(l.label)}`}
              className="block px-6 py-4 font-mono text-xs tracking-[0.2em] uppercase text-slate-700 border-b border-slate-100 hover:bg-blueprint-light transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
          <a
            href={CONTACT.phoneHref}
            data-testid="nav-mobile-phone-link"
            className="block px-6 py-4 font-mono text-xs tracking-widest text-blueprint-accent"
          >
            {CONTACT.phoneDisplay}
          </a>
        </div>
      )}
    </header>
  );
};

export default Navbar;
